<div class="d-flex flex-column h-100" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle data-cy="collage-border-container">
  <div class="row mb-3" data-cy="collage-border-color-row">
    <div class="col-3 text-right" data-cy="collage-border-color-label-col">
      <label data-cy="collage-border-color-label">Border Color: </label>
    </div>
    <div class="col-9" (mousedown)="$event.stopImmediatePropagation()" data-cy="collage-border-color-field-col">
      <dx-color-box [(value)]="color" placeHolder="Border Color"
                    (onValueChanged)="handleColor($event)"
                    style="margin-top: -7px" data-cy="collage-border-color-picker">
      </dx-color-box>
    </div>
  </div>

  <div class="row mb-3" data-cy="collage-border-thickness-row">
    <div class="col-3 text-right" data-cy="collage-border-thickness-label-col">
      <label data-cy="collage-border-thickness-label">Thickness: </label>
    </div>
    <div class="col-9" (mousedown)="$event.stopImmediatePropagation()" data-cy="collage-border-thickness-slider-col">
      <!-- TODO: The 'tickInterval' property no longer exists -->
      <mat-slider class="w-100" thumbLabel min="0" max="20" style="margin-top: -10px" #ngSlider data-cy="collage-border-thickness-slider"><input matSliderThumb [value]="thickness" (input)="handleThickness({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value})" #ngSliderThumb="matSliderThumb" data-cy="collage-border-thickness-input" />
      </mat-slider>
    </div>
  </div>
    
  <div class="row mb-2" data-cy="collage-border-radius-row">
    <div class="col-3 text-right" data-cy="collage-border-radius-label-col">
      <label data-cy="collage-border-radius-label">Radius: </label>
    </div>
    <div class="col-9" (mousedown)="$event.stopImmediatePropagation()" data-cy="collage-border-radius-slider-col">
      <!-- TODO: The 'tickInterval' property no longer exists -->
      <mat-slider class="w-100" thumbLabel min="0" max="10" style="margin-top: -10px" #ngSlider data-cy="collage-border-radius-slider"><input matSliderThumb [value]="radius" (input)="handleRadius({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value})" #ngSliderThumb="matSliderThumb" data-cy="collage-border-radius-input" />
      </mat-slider>
    </div>
  </div>

  <div class="d-flex justify-content-end mt-auto" data-cy="collage-border-actions">
    <div class="mr-auto"></div>
    <div (mousedown)="$event.stopImmediatePropagation()" data-cy="collage-border-buttons">
      <button mat-button class="tdox-btn tdox-btn-cancel mr-2" (click)="cancel()"
              style="width: 125px" data-cy="collage-border-cancel-button">
        Cancel
      </button>
      <button mat-button class="tdox-btn tdox-btn-primary" (click)="apply()"
              style="width: 125px" data-cy="collage-border-apply-button">
        Apply
      </button>
    </div>
  </div>
</div>
